import React, { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import classNames from 'classnames';

type ModalWrapperProps = ComponentPropsWithoutRef<'div'> & PropsWithChildren;

const ModalWrapper = ({ children, className, ...rest }: ModalWrapperProps) => {
  const combinedClassName = classNames('mb-2', className);

  return (
    <div className={combinedClassName} {...rest}>
      {children}
    </div>
  );
};

export default ModalWrapper;
